import { render, staticRenderFns } from "./SectionCardsPopupInfo.vue?vue&type=template&id=0ba96d65&scoped=true&"
import script from "./SectionCardsPopupInfo.vue?vue&type=script&lang=ts&"
export * from "./SectionCardsPopupInfo.vue?vue&type=script&lang=ts&"
import style0 from "./SectionCardsPopupInfo.vue?vue&type=style&index=0&id=0ba96d65&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba96d65",
  null
  
)

export default component.exports